module.exports = __webpack_public_path__ + "static/media/portada1920_1080_escritorio_grande.bb623d61.png";